export default __webpack_public_path__ + "static/media/13.fbfdc9f1.png";